import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { fontFamily, heading1Obj } = typographyStyles;

export const titleCss = [
  {
    color: colors.ui.neutral[600],
    margin: "0 0 24px",
    textAlign: "center",
  },
  fontFamily.noto,
  heading1Obj,
];
